import type {
  ArtGenresApiSortingEnum,
  CollectionDetailedSerializer,
  IApiResponse,
  FacetedArtsDataSerializer,
  FacetedArtsResponseSerializer,
} from "@litres-libs/types";
import { rtkqApi } from "../api/rtkqApi";
import type { IArtsFacetsRequest } from "../../types/api";
import { TagsType } from "../constants";

export interface ITagsArtsFacetsRequest extends IArtsFacetsRequest {
  tagIdOrSlug: string | number;
  o?: `${ArtGenresApiSortingEnum}`;
}

export const tagsApi = rtkqApi.injectEndpoints({
  endpoints: build => ({
    getTagsNaming: build.query<
      CollectionDetailedSerializer,
      {
        tagIdOrSlug: number | string;
      }
    >({
      query: ({ tagIdOrSlug }) => ({
        url: `/foundation/api/tags/${tagIdOrSlug}`,
      }),
      transformResponse: (
        response: IApiResponse<CollectionDetailedSerializer>
      ) => {
        return response.payload.data;
      },
    }),
    /** запрос на фасеты для новой сетки, мерж  не нужен
     */
    getTagFacets: build.query<
      FacetedArtsDataSerializer,
      ITagsArtsFacetsRequest
    >({
      query: ({ tagIdOrSlug, limit = 24, offset = "0", ...params }) => ({
        url: `/foundation/api/tags/${tagIdOrSlug}/arts/facets`,
        params: {
          ...params,
          limit,
          offset,
        },
        headers: {
          "accept-version": "2",
        },
      }),
      transformResponse: (response: FacetedArtsResponseSerializer) =>
        response.payload,
      providesTags: result =>
        result
          ? [
              ...result.data.map(({ id }) => ({
                type: TagsType.ART_SHORT_LIST as const,
                id,
              })),
              TagsType.ART_SHORT_LIST,
              // инвалидируем  информацию о всех фасетах тэга (нужно для перехода с ?promocode=<...>)
              { type: TagsType.TAG_FACETS, id: "TAG_FACETS" },
            ]
          : [
              { type: TagsType.TAG_FACETS, id: "TAG_FACETS" },
              TagsType.ART_SHORT_LIST,
            ],
    }),
  }),
});
